module.exports = __webpack_public_path__ + "img/06.f0b4173a.jpg";